import type { UseCurrencyOutputOptions } from 'BreetHelpers';

export const useCurrencyOutput =
	() =>
	(
		value: string | number | UseCurrencyOutputOptions = 0,
		round = 2,
		minimumRoundNum = 0,
		conversionRate = 1,
		returnUndefined = false
	) => {
		const options = typeof value === 'object' ? value : undefined;

		const valueAsNumber = Number(options ? (options.value ?? 0) : value);

		if ((returnUndefined && Number.isNaN(valueAsNumber)) || (options && options.returnUndefined && Number.isNaN(valueAsNumber)))
			return undefined;
		if ((returnUndefined && !valueAsNumber) || (options && options.returnUndefined && !valueAsNumber)) return undefined;

		if (options) {
			const rawValue = valueAsNumber / (options.conversionRate ?? 1);

			const factor = 10 ** (options.roundTo ?? 2);
			let roundedValue = 0;
			const mode = options.roundMode ?? 'round';

			if (mode === 'floor') roundedValue = Math.floor(rawValue * factor) / factor;
			if (mode === 'ceil') roundedValue = Math.ceil(rawValue * factor) / factor;
			if (mode === 'round') roundedValue = Math.round(rawValue * factor) / factor;

			return roundedValue.toLocaleString(undefined, {
				minimumFractionDigits: options.minimumRoundNum ?? 0,
				maximumFractionDigits: options.roundTo ?? 2,
			});
		}

		const rawValueInt = valueAsNumber / conversionRate;

		return rawValueInt.toLocaleString(undefined, {
			minimumFractionDigits: minimumRoundNum,
			maximumFractionDigits: round,
		});
	};
